/**
 * Location hooks — portal dropdown support for manual lead creation.
 *
 * useLocations: fetches active org locations for the LeadCreatePage dropdown.
 */
import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@/lib/api-client.js';

export interface LocationItem {
  id: string;
  name: string | null;
  city: string | null;
  state: string | null;
  business_id: string;
  business_name: string;
}

interface LocationListResponse {
  locations: LocationItem[];
}

/**
 * Returns active locations for the authenticated user's org.
 * Cached for 5 minutes — locations change infrequently.
 *
 * Pass `enabled: false` for callers that render without an org context
 * (super admins) — /v1/locations is org-scoped and rejects them.
 */
export function useLocations(options?: { enabled?: boolean }) {
  return useQuery<LocationListResponse>({
    queryKey: ['locations'],
    queryFn: () => apiClient.get<LocationListResponse>('/v1/locations'),
    staleTime: 300_000,
    enabled: options?.enabled ?? true,
  });
}
